import { PageContainer } from '@components/PageContainer';
import { RoutedTabs } from '@components/RoutedTabs';
import { useFeatureContext } from '@contexts/FeatureContext';
import { GlobeIcon, TransferIcon } from '@gurupay/gp-ui-library';
import { useTranslation } from 'react-i18next';

const NewTransfer = () => {
	const { t } = useTranslation();
	const featureContext = useFeatureContext();

	const tabsItems = [
		{
			label: t('payments.newPayment.tab'),
			to: 'sepa',
			icon: <TransferIcon className="w-space-16 h-space-16" />,
		},
		{
			label: t('payments.international.tab'),
			to: 'international',
			icon: <GlobeIcon className="w-space-16 h-space-16" />,
			disabled: featureContext?.data?.status !== 'OPENED',
		},
		{
			label: t('payments.newPayment.additionalData.fx.tab'),
			to: 'fx',
			icon: <GlobeIcon className="w-space-16 h-space-16" />,
			disabled: featureContext?.data?.status !== 'OPENED',
		},
	];

	return (
		<PageContainer icon={<TransferIcon />} title={t('payments.title')}>
			<div>
				<RoutedTabs tabs={tabsItems} />
			</div>
		</PageContainer>
	);
};

export const Orders = () => <NewTransfer />;
